import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);
  
  // Phone number - remove spaces and special characters for WhatsApp link
  const phoneNumber = "13058341149"; // +1 (305) 834-1149
  const message = "Hello! I'm interested in your epoxy flooring services.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  useEffect(() => {
    // Show button after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    // Hide tooltip after 5 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const handleClick = () => {
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      {/* WhatsApp Floating Button */}
      <div
        className={`fixed bottom-6 right-6 z-[9999] transition-all duration-500 ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0"
        }`}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg text-sm whitespace-nowrap animate-bounce">
            <div className="flex items-center gap-2">
              <span>Chat with us on WhatsApp!</span>
              <button
                onClick={() => setShowTooltip(false)}
                className="text-white hover:text-gray-300"
              >
                <X size={16} />
              </button>
            </div>
            <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
          </div>
        )}

        {/* Button */}
        <button
          onClick={handleClick}
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full px-6 py-4 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110 flex items-center gap-3"
          aria-label="Contact us on WhatsApp"
        >
          {/* WhatsApp Icon */}
          <div className="relative">
            <MessageCircle size={28} fill="currentColor" />
            {/* Pulse animation */}
            <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
          </div>
          
          {/* Text - Always visible */}
          <span className="text-base font-semibold whitespace-nowrap">
            Escríbenos
          </span>
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
